import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons-img/camera.svg'


const _withScopeId = n => (_pushScopeId("data-v-64ee4398"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-wrapper"
}
const _hoisted_2 = { class: "chat-info" }
const _hoisted_3 = { class: "image-wrapper" }
const _hoisted_4 = {
  for: "img-uploader",
  class: "img-uploader"
}
const _hoisted_5 = {
  key: 0,
  class: "icon"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "camera icon"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "edit-name"
}
const _hoisted_9 = {
  key: 1,
  class: "group-title"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "scroll" }
const _hoisted_13 = {
  key: 0,
  class: "mt-15"
}
const _hoisted_14 = { class: "share-media-list" }
const _hoisted_15 = { class: "share-media--item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-tablet" }, null, -1))
const _hoisted_17 = { class: "share-media--item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_19 = { class: "share-media--item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Make group public ")
const _hoisted_22 = {
  key: 2,
  class: "mt-15"
}
const _hoisted_23 = { class: "buttons-box" }
const _hoisted_24 = { class: "section-title" }
const _hoisted_25 = {
  key: 3,
  class: "mt-15"
}
const _hoisted_26 = { class: "buttons-box" }
const _hoisted_27 = { class: "section-title" }
const _hoisted_28 = {
  key: 5,
  class: "manage"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon manage__icon icon-logout" }, null, -1))
const _hoisted_30 = { class: "manage__container" }
const _hoisted_31 = { class: "manage__title" }
const _hoisted_32 = {
  key: 0,
  class: "manage__text"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon manage__icon icon-settings2" }, null, -1))
const _hoisted_34 = { class: "manage__container" }
const _hoisted_35 = { class: "manage__title" }
const _hoisted_36 = { class: "manage__text" }
const _hoisted_37 = {
  key: 1,
  class: "d-list-wrapper"
}
const _hoisted_38 = { class: "d-group-info" }
const _hoisted_39 = { class: "d-aside" }
const _hoisted_40 = { class: "d-aside__main-menu" }
const _hoisted_41 = { class: "d-scroll" }
const _hoisted_42 = { class: "chat-info" }
const _hoisted_43 = { class: "image-wrapper" }
const _hoisted_44 = {
  for: "img-uploader",
  class: "img-uploader"
}
const _hoisted_45 = {
  key: 0,
  class: "icon"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "camera icon"
}, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 0,
  class: "edit-name"
}
const _hoisted_49 = {
  key: 1,
  class: "group-title"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 1,
  class: "mt-15"
}
const _hoisted_53 = { class: "d-share-media-list" }
const _hoisted_54 = { class: "share-media--item" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-tablet" }, null, -1))
const _hoisted_56 = { class: "share-media--item" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_58 = { class: "share-media--item" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file" }, null, -1))
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Make group public ")
const _hoisted_61 = {
  key: 3,
  class: "mt-15"
}
const _hoisted_62 = { class: "buttons-box" }
const _hoisted_63 = { class: "section-title" }
const _hoisted_64 = {
  key: 4,
  class: "mt-15"
}
const _hoisted_65 = { class: "buttons-box" }
const _hoisted_66 = { class: "section-title" }
const _hoisted_67 = {
  key: 6,
  class: "manage"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon manage__icon icon-logout" }, null, -1))
const _hoisted_69 = { class: "manage__container" }
const _hoisted_70 = { class: "manage__title" }
const _hoisted_71 = {
  key: 0,
  class: "manage__text"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon manage__icon icon-settings2" }, null, -1))
const _hoisted_73 = { class: "manage__container" }
const _hoisted_74 = { class: "manage__title" }
const _hoisted_75 = { class: "manage__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_app_take_photo = _resolveComponent("app-take-photo")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_Form = _resolveComponent("Form")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_toggle = _resolveComponent("app-toggle")!
  const _component_spaces_user = _resolveComponent("spaces-user")!
  const _component_app_upload_info = _resolveComponent("app-upload-info")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_message_group_add_people = _resolveComponent("message-group-add-people")!
  const _component_message_group_files = _resolveComponent("message-group-files")!
  const _component_message_group_leave_confirmation = _resolveComponent("message-group-leave-confirmation")!
  const _component_message_group_delete_confirmation = _resolveComponent("message-group-delete-confirmation")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_header, {
          customTitle: _ctx.$localize('group.settings.header')
        }, {
          bottom: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _createVNode(_component_app_lazy_image, {
                    url: _ctx.photoUrl,
                    key: _ctx.photoUrl,
                    class: "img"
                  }, null, 8, ["url"]),
                  (_ctx.isGroupOwner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isGroupOwner)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: _ctx.fileInputKey,
                      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.savePhoto && _ctx.savePhoto(...args))),
                      accept: "image/png, image/jpg, image/jpeg",
                      id: "img-uploader",
                      class: "img-uploader",
                      type: "file",
                      ref: "fileInput"
                    }, null, 544)), [
                      [_vShow, false]
                    ])
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
                _createVNode(_component_app_take_photo, {
                  image: _ctx.imageToCrop,
                  onOnCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imageToCrop = {})),
                  onOnDone: _ctx.handleCroppedImage,
                  singleUpload: "",
                  hideOptionsList: ""
                }, null, 8, ["image", "onOnDone"])
              ])),
              (_ctx.messagesStore.currentConversation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.editNameMode)
                      ? (_openBlock(), _createBlock(_component_Form, {
                          key: 0,
                          class: "w-100",
                          as: "el-form",
                          "validation-schema": _ctx.schema
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_app_input, {
                              modelValue: _ctx.messagesStore.currentConversation.info.name,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.messagesStore.currentConversation.info.name) = $event)),
                              name: "groupName",
                              label: "Group Name",
                              placeholder: "Add a name for your group",
                              onInput: _ctx.validate
                            }, null, 8, ["modelValue", "onInput"])
                          ]),
                          _: 1
                        }, 8, ["validation-schema"]))
                      : (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_ctx.messagesStore.currentConversation?.info.name), 1)),
                    (_ctx.isGroupOwner)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass(["icon", [_ctx.editNameMode ? 'icon-check' : 'icon-edit', _ctx.isValid ? '' : 'disabled']]),
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onEditMode && _ctx.onEditMode(...args)))
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          "top-left": _withCtx(() => [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)), ["prevent"])),
              class: "back-link"
            }, _hoisted_11)
          ]),
          _: 1
        }, 8, ["customTitle"]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.isGroupMember)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "share-media",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSharedItems = _ctx.MESSAGE_SHARED_ITEM_TYPES.CASE_TYPE))
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$localize('group.settings.share.media.type.cases')), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "share-media",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSharedItems = _ctx.MESSAGE_SHARED_ITEM_TYPES.PHOTO_TYPE))
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$localize('group.settings.share.media.type.photos')), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "share-media",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showSharedItems = _ctx.MESSAGE_SHARED_ITEM_TYPES.FILE_TYPE))
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$localize('group.settings.share.media.type.files')), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isGroupAdmin)
            ? (_openBlock(), _createBlock(_component_app_toggle, {
                key: 1,
                onClick: _ctx.makeGroupPublic,
                checked: _ctx.messagesStore.currentConversation?.group?.groupType === _ctx.GROUP_TYPE.PUBLIC_OPEN,
                id: "public-toggle"
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["onClick", "checked"]))
            : _createCommentVNode("", true),
          (_ctx.requestsToGroup.length && _ctx.isGroupAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.$localize('group.settings.requestsToGroup')) + " (" + _toDisplayString(_ctx.requestsToGroup.length || 0) + ") ", 1),
                  (_ctx.requestsToGroup.length > 10)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "more-link",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.isViewAllRequestsToGroup = !_ctx.isViewAllRequestsToGroup;})
                      }, _toDisplayString(!_ctx.isViewAllRequestsToGroup ? _ctx.$localize('drive.section.button.view_all') : _ctx.$localize('drive.section.button.less_all')), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRequestsToGroup, (request) => {
            return (_openBlock(), _createBlock(_component_spaces_user, {
              user: request.partner,
              key: request.partner.accountId,
              "user-type": _ctx.NETWORK_CONTACT_TYPES.GROUP_REQUESTS,
              "group-info": _ctx.messagesStore.currentConversation?.group,
              onAcceptUserToGroup: _ctx.acceptUserToGroup,
              onRejectUserToGroup: _ctx.rejectUserToGroup
            }, null, 8, ["user", "user-type", "group-info", "onAcceptUserToGroup", "onRejectUserToGroup"]))
          }), 128)),
          (_ctx.isGroupMember)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("h4", _hoisted_27, _toDisplayString(_ctx.$localize('group.settings.members.count')) + " (" + _toDisplayString(_ctx.messagesStore.currentConversation?.group?.members.length || 0) + ") ", 1),
                  (_ctx.messagesStore.currentConversation?.group?.members.length > 10)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "more-link",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.viewAllMembers && _ctx.viewAllMembers(...args)))
                      }, _toDisplayString(!_ctx.isViewAllMembers ? _ctx.$localize('drive.section.button.view_all') : _ctx.$localize('drive.section.button.less_all')), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isGroupOwner)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "add-members",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addContacts = true))
                    }, _toDisplayString(_ctx.$localize('group.settings.add.members')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isGroupMember)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.members, (user) => {
                return (_openBlock(), _createBlock(_component_spaces_user, {
                  user: user,
                  key: user.accountId + Date.now(),
                  "user-type": _ctx.NETWORK_CONTACT_TYPES.GROUP_MANAGE,
                  "group-info": _ctx.messagesStore.currentConversation?.group,
                  onCloseGroupInfo: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close'))),
                  onHandleUserUpdate: _ctx.fetchGroupData
                }, null, 8, ["user", "user-type", "group-info", "onHandleUserUpdate"]))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.isGroupMember)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", {
                  class: _normalizeClass(["manage__item", { disabled: _ctx.isGroupOwner }]),
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.openGroupLeaveConfirm && _ctx.openGroupLeaveConfirm(...args)))
                }, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.$localize('group.settings.leave.group')), 1),
                    (_ctx.isGroupOwner)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.$localize('group.settings.leave.group.owner.warning')), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                (_ctx.isGroupOwner)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openGroupDeleteConfirm && _ctx.openGroupDeleteConfirm(...args))),
                      class: "manage__item manage__item-last"
                    }, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.$localize('group.settings.delete.group')), 1),
                        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$localize('group.settings.delete.group.warning')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: _ctx.loaderText
            }, {
              default: _withCtx(() => [
                (_ctx.dataLoading && _ctx.uploadInfo.total)
                  ? (_openBlock(), _createBlock(_component_app_upload_info, {
                      key: 0,
                      "upload-info": _ctx.uploadInfo,
                      onCancelUpload: _ctx.cancelUpload
                    }, null, 8, ["upload-info", "onCancelUpload"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["message"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          (_ctx.addContacts)
            ? (_openBlock(), _createBlock(_component_message_group_add_people, {
                key: 0,
                onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addContacts = false))
              }))
            : _createCommentVNode("", true)
        ])),
        (_ctx.showSharedItems)
          ? (_openBlock(), _createBlock(_component_message_group_files, {
              key: 1,
              type: _ctx.showSharedItems,
              onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showSharedItems = null))
            }, null, 8, ["type"]))
          : _createCommentVNode("", true),
        (_ctx.groupLeaveConfirm)
          ? (_openBlock(), _createBlock(_component_message_group_leave_confirmation, {
              key: 2,
              onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.groupLeaveConfirm = false)),
              onSave: _cache[17] || (_cache[17] = ($event: any) => (_ctx.leaveGroup('SAVE'))),
              onRemove: _cache[18] || (_cache[18] = ($event: any) => (_ctx.leaveGroup('REMOVE'))),
              class: "align-popup"
            }))
          : _createCommentVNode("", true),
        (_ctx.groupDeleteConfirm)
          ? (_openBlock(), _createBlock(_component_message_group_delete_confirmation, {
              key: 3,
              onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.groupDeleteConfirm = false)),
              onDelete: _cache[20] || (_cache[20] = ($event: any) => (_ctx.deleteGroup())),
              class: "align-popup"
            }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_37, [
        _createVNode(_component_desktop_header),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("aside", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_drive_aside_main_menu)
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("label", _hoisted_44, [
                  _createVNode(_component_app_lazy_image, {
                    url: _ctx.photoUrl,
                    key: _ctx.photoUrl,
                    class: "img"
                  }, null, 8, ["url"]),
                  (_ctx.isGroupOwner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isGroupOwner)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: _ctx.fileInputKey,
                      onInput: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.savePhoto && _ctx.savePhoto(...args))),
                      accept: "image/png, image/jpg, image/jpeg",
                      id: "img-uploader",
                      class: "img-uploader",
                      type: "file",
                      ref: "fileInput"
                    }, null, 544)), [
                      [_vShow, false]
                    ])
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
                _createVNode(_component_app_take_photo, {
                  image: _ctx.imageToCrop,
                  onOnCancel: _cache[22] || (_cache[22] = ($event: any) => (_ctx.imageToCrop = {})),
                  onOnDone: _ctx.handleCroppedImage,
                  singleUpload: "",
                  hideOptionsList: ""
                }, null, 8, ["image", "onOnDone"])
              ])),
              (_ctx.messagesStore.currentConversation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    (_ctx.editNameMode)
                      ? (_openBlock(), _createBlock(_component_Form, {
                          key: 0,
                          class: "w-100",
                          as: "el-form",
                          "validation-schema": _ctx.schema
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_app_input, {
                              modelValue: _ctx.messagesStore.currentConversation.info.name,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.messagesStore.currentConversation.info.name) = $event)),
                              name: "groupName",
                              label: "Group Name",
                              placeholder: "Add a name for your group",
                              onInput: _ctx.validate
                            }, null, 8, ["modelValue", "onInput"])
                          ]),
                          _: 1
                        }, 8, ["validation-schema"]))
                      : (_openBlock(), _createElementBlock("h3", _hoisted_49, _toDisplayString(_ctx.messagesStore.currentConversation?.info.name), 1)),
                    (_ctx.isGroupOwner)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass(["icon", [_ctx.editNameMode ? 'icon-check' : 'icon-edit', _ctx.isValid ? '' : 'disabled']]),
                          onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onEditMode && _ctx.onEditMode(...args)))
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.showSharedItems)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:void(0);",
                  onClick: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)), ["prevent"])),
                  class: "back-link"
                }, _hoisted_51))
              : _createCommentVNode("", true),
            (_ctx.isGroupMember)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", {
                      class: "share-media",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showSharedItems = _ctx.MESSAGE_SHARED_ITEM_TYPES.CASE_TYPE))
                    }, [
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("p", null, _toDisplayString(_ctx.$localize('group.settings.share.media.type.cases')), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "share-media",
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showSharedItems = _ctx.MESSAGE_SHARED_ITEM_TYPES.PHOTO_TYPE))
                    }, [
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("p", null, _toDisplayString(_ctx.$localize('group.settings.share.media.type.photos')), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "share-media",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showSharedItems = _ctx.MESSAGE_SHARED_ITEM_TYPES.FILE_TYPE))
                    }, [
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("p", null, _toDisplayString(_ctx.$localize('group.settings.share.media.type.files')), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isGroupAdmin)
              ? (_openBlock(), _createBlock(_component_app_toggle, {
                  key: 2,
                  onClick: _ctx.makeGroupPublic,
                  checked: _ctx.messagesStore.currentConversation?.group?.groupType === _ctx.GROUP_TYPE.PUBLIC_OPEN,
                  id: "public-toggle"
                }, {
                  default: _withCtx(() => [
                    _hoisted_60
                  ]),
                  _: 1
                }, 8, ["onClick", "checked"]))
              : _createCommentVNode("", true),
            (_ctx.requestsToGroup.length && _ctx.isGroupAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("h4", _hoisted_63, _toDisplayString(_ctx.$localize('group.settings.requestsToGroup')) + " (" + _toDisplayString(_ctx.requestsToGroup.length || 0) + ") ", 1),
                    (_ctx.requestsToGroup.length > 10)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "more-link",
                          onClick: _cache[29] || (_cache[29] = ($event: any) => {_ctx.isViewAllRequestsToGroup = !_ctx.isViewAllRequestsToGroup;})
                        }, _toDisplayString(!_ctx.isViewAllRequestsToGroup ? _ctx.$localize('drive.section.button.view_all') : _ctx.$localize('drive.section.button.less_all')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRequestsToGroup, (request) => {
              return (_openBlock(), _createBlock(_component_spaces_user, {
                user: request.networkUser,
                key: request.networkUser.accountId,
                "user-type": _ctx.NETWORK_CONTACT_TYPES.GROUP_REQUESTS,
                "group-info": _ctx.messagesStore.currentConversation?.group,
                onAcceptUserToGroup: _ctx.acceptUserToGroup,
                onRejectUserToGroup: _ctx.rejectUserToGroup
              }, null, 8, ["user", "user-type", "group-info", "onAcceptUserToGroup", "onRejectUserToGroup"]))
            }), 128)),
            (_ctx.isGroupMember)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("h4", _hoisted_66, _toDisplayString(_ctx.$localize('group.settings.members.count')) + " (" + _toDisplayString(_ctx.messagesStore.currentConversation?.group?.members.length || 0) + ") ", 1),
                    (_ctx.messagesStore.currentConversation?.group?.members.length > 10)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "more-link",
                          onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.viewAllMembers && _ctx.viewAllMembers(...args)))
                        }, _toDisplayString(!_ctx.isViewAllMembers ? _ctx.$localize('drive.section.button.view_all') : _ctx.$localize('drive.section.button.less_all')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.isGroupOwner)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "add-members",
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.addContacts = true))
                      }, _toDisplayString(_ctx.$localize('group.settings.add.members')), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isGroupMember)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(_ctx.members, (user) => {
                  return (_openBlock(), _createBlock(_component_spaces_user, {
                    user: user,
                    key: user.accountId + Date.now(),
                    "user-type": _ctx.NETWORK_CONTACT_TYPES.GROUP_MANAGE,
                    "group-info": _ctx.messagesStore.currentConversation?.group,
                    onCloseGroupInfo: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$emit('close'))),
                    onHandleUserUpdate: _ctx.fetchGroupData
                  }, null, 8, ["user", "user-type", "group-info", "onHandleUserUpdate"]))
                }), 128))
              : _createCommentVNode("", true),
            (_ctx.isGroupMember)
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["manage__item", { disabled: _ctx.isGroupOwner }]),
                    onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.openGroupLeaveConfirm && _ctx.openGroupLeaveConfirm(...args)))
                  }, [
                    _hoisted_68,
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("h3", _hoisted_70, _toDisplayString(_ctx.$localize('group.settings.leave.group')), 1),
                      (_ctx.isGroupOwner)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_71, _toDisplayString(_ctx.$localize('group.settings.leave.group.owner.warning')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  (_ctx.isGroupOwner)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.openGroupDeleteConfirm && _ctx.openGroupDeleteConfirm(...args))),
                        class: "manage__item manage__item-last"
                      }, [
                        _hoisted_72,
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("h3", _hoisted_74, _toDisplayString(_ctx.$localize('group.settings.delete.group')), 1),
                          _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.$localize('group.settings.delete.group.warning')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: _ctx.loaderText
            }, {
              default: _withCtx(() => [
                (_ctx.dataLoading && _ctx.uploadInfo.total)
                  ? (_openBlock(), _createBlock(_component_app_upload_info, {
                      key: 0,
                      "upload-info": _ctx.uploadInfo,
                      onCancelUpload: _ctx.cancelUpload
                    }, null, 8, ["upload-info", "onCancelUpload"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["message"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          (_ctx.addContacts)
            ? (_openBlock(), _createBlock(_component_message_group_add_people, {
                key: 0,
                onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.addContacts = false))
              }))
            : _createCommentVNode("", true)
        ])),
        (_ctx.showSharedItems)
          ? (_openBlock(), _createBlock(_component_message_group_files, {
              key: 1,
              type: _ctx.showSharedItems,
              onClose: _cache[36] || (_cache[36] = ($event: any) => (_ctx.showSharedItems = null))
            }, null, 8, ["type"]))
          : _createCommentVNode("", true),
        (_ctx.groupLeaveConfirm)
          ? (_openBlock(), _createBlock(_component_message_group_leave_confirmation, {
              key: 2,
              onClose: _cache[37] || (_cache[37] = ($event: any) => (_ctx.groupLeaveConfirm = false)),
              onSave: _cache[38] || (_cache[38] = ($event: any) => (_ctx.leaveGroup('SAVE'))),
              onRemove: _cache[39] || (_cache[39] = ($event: any) => (_ctx.leaveGroup('REMOVE'))),
              class: "align-popup"
            }))
          : _createCommentVNode("", true),
        (_ctx.groupDeleteConfirm)
          ? (_openBlock(), _createBlock(_component_message_group_delete_confirmation, {
              key: 3,
              onClose: _cache[40] || (_cache[40] = ($event: any) => (_ctx.groupDeleteConfirm = false)),
              onDelete: _cache[41] || (_cache[41] = ($event: any) => (_ctx.deleteGroup())),
              class: "align-popup"
            }))
          : _createCommentVNode("", true)
      ]))
}